export default landscapeCanvas

/** @ngInject */
function landscapeCanvas($location, $state, $stateParams, LandscapeElements) {
    return ({
        restrict: 'E',
        replace: true,
        template: require('./view.jade')(),
        scope: {},
        link(scope, element, attrs) {
            scope.LE = LandscapeElements
            scope.$watchCollection('LE.LandscapeElements', (landscapeElements) => {
                scope.landscapeElements = landscapeElements
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/landscape-canvas/directive.js